<template lang="pug">
.v-switchers.switchers
	.switchers__item.flc(v-if="country")
		.switcher
			.switcher__label {{country.label}}
			.switcher__input
				template(v-for="(option, optionIndex) in country.options" :key="optionIndex")
					button.switcher__btn(:class="{'switcher__btn--active': option.value === countryLocalValue}"
							type="button" @click="selectCountryValue(optionIndex)") {{option.text}}
	.switchers__item.flc(v-if="currency")
		.switcher
			.switcher__label {{currency.label}}
			.switcher__input
				template(v-for="(option, optionIndex) in currency.options" :key="optionIndex")
					button.switcher__btn(:class="{'switcher__btn--active': option.value === currencyLocalValue}"
							type="button" @click="selectCurrencyValue(optionIndex)") {{option.text}}
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
	data() {
		return {
			delivery: null,
			countryLocalValue: null,
			currencyLocalValue: null
		}
	},

	computed: {
		...mapGetters({
			country: 'delivery/country',
			currency: 'delivery/currency'
		})
	},

	watch: {
		country() {
			this.countryLocalValue = this.country.value;
		},

		currency() {
			this.currencyLocalValue = this.currency.value;
		}
	},

	mounted() {
		if (this.country) {
			this.countryLocalValue = this.country.value;
		}

		if (this.currency) {
			this.currencyLocalValue = this.currency.value;
		}
	},

	methods: {
		...mapActions({
			setCountryValue: 'delivery/setCountryValue',
			setCurrencyValue: 'delivery/setCurrencyValue'
		}),

		selectCountryValue(index) {
			this.countryLocalValue = this.country.options[index].value;
			this.setCountryValue({
				value: this.countryLocalValue
			});
		},

		selectCurrencyValue(index) {
			this.currencyLocalValue = this.currency.options[index].value;
			this.setCurrencyValue({
				value: this.currencyLocalValue
			});
		}
	},
};
</script>